import ModalService from './ModalService'

const ID_SNACKBAR = 'muven-new-update-snackbar'
const TIMEOUT = 30 * 1000
let idTimeout:any = null

export default {
    show() {
        clearTimeout(idTimeout)

        document.getElementById(ID_SNACKBAR)?.classList.add('active')

        idTimeout = setTimeout(() => {
            this.hide()
        }, TIMEOUT)
    },
    hide() {
        document.getElementById(ID_SNACKBAR)?.classList.remove('active')
    },
}
